import layout from "@/layouts/dashboard";

export default [
    {
        path: "/dashboard/setting",
        name: "setting",
        component: layout,
        redirect: {
            name: "dashboard-setting-user",
        },
        children: [
            {
                path: "user/:type(\\w+)?",
                name: "dashboard-setting-user",
                component: () => import("@/views/setting/user"),
                meta: {
                    titleKey: "common.routes.userTitle",
                    descKey: "common.routes.userDesc",
                },
            },
            // 基本信息
            // {
            //     path: "info",
            //     name: "dashboard-setting-info",
            //     component: () => import("@/views/setting/info"),
            //     meta: {
            //         titleKey: "common.routes.infoTitle",
            //         descKey: "common.routes.infoDesc",
            //         activeMenu: "dashboard-setting-user",
            //     },
            // },
            // {
            //     path: "profile",
            //     name: "dashboard-setting-profile",
            //     component: () => import("@/views/setting/profile"),
            //     meta: {
            //         titleKey: "common.routes.profileTitle",
            //         descKey: "common.routes.profileDesc",
            //         activeMenu: "dashboard-setting-user",
            //     },
            // },
            // 地址管理
            {
                path: "address",
                name: "dashboard-setting-address",
                component: () => import("@/views/setting/address"),
                meta: {
                    titleKey: "common.routes.addressTitle",
                    descKey: "common.routes.addressDesc",
                },
            },
            {
                path: "connect",
                name: "dashboard-setting-connect",
                component: () => import("@/views/setting/connect"),
                meta: {
                    titleKey: "common.routes.connectTitle",
                    descKey: "common.routes.connectDesc",
                },
            },
        ],
    },
];
